var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"font-size":"1.5rem","text-align":"center","padding-top":"2rem"}},[_vm._v(_vm._s(_vm.$t('FAQ')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataset)}})])}
var staticRenderFns = []

export { render, staticRenderFns }